import StockUtil from './util';
export const type_list = [
    {
        title: '采购入库单',
        value: 'in_stock'
    },
    {
        title: '采购退料单',
        value: 'return_stock'
    },
    {
        title: '其他入库单',
        value: 'other_in_stock'
    },
    {
        title: '组装拆卸单',
        value: 'assemble_in_stock'
    },
    {
        title: '未定义入库类型',
        value: ''
    }
]
export const print_table_fields = [
    {
        title: '入库单号',
        key: 'bill_no'
    },
    {
        title: '入库类型',
        key: 'in_type',
        render: (h, params) => {
            return <span class="value"> {StockUtil.getInTypeName(params.in_type)}</span>
        }
    },
    {
        title: '采购合同',
        key:'contract_uid',
        render: (h, params) => {
            if (params.contract_id > 0) {
                return <p class="value"> {params.contract_uid}</p>
            } else {
                return (
                <div>
                    {params.contract_uid && <span class="value"> {params.contract_uid}</span>}
                    <p class="value"> 未关联合同</p>
                </div>)
            }
        }
    },
    {
        title: '存货',
        key: 'test_1',
        render: (h, params) => {
            const row = params;
            const stock = row.stock;
            if (stock) {
                return (<div>
                    <p class="value"> {stock.uid}</p>
                    <p class="value"> {stock.name}</p>
                </div>)
            } else {
                return <p class="value"> {row.stock_uid.split('-')[0]}</p>
            }
        }
    },
    {
        title: '入库数量',
        key:'qty',
    },
    {
        title: '含税单价',
        key:'unit_price',
    },
    {
        title: '总价',
        key: 'total_price',
    },
    {
        title: '入库日期',
        key: 'in_date'
    },

    {
        title: '供应商',
        key: 'supplier_name',
        render: (h, params) => {
            return <span class={'value'}>{params.supplier_name || '-'}</span>
        }
    },
    {
        title: '仓库',
        key: 'warehouse_name',
        render: (h, params) => {
            return <span class={'value'}>{params.warehouse_name || '-'}</span>
        }
    },

    {
        title: '单据备注',
        key: 'bill_note',
    },
    {
        title: '明细备注',
        key: 'list_note',
    },
    {
        title: '审核状态',
        key: 'audited',
        render: (h, params) => {
            return <span class={'value'}>{params.audited ? '已审核' : '未审核'}</span>
        }
    },
]

export const audited_status = [
    {
        title: '全部',
        value: 3
    },
    {
        title: '未审核',
        value: 1
    },
    {   
        title: '已审核',
        value: 2
    }
]

export const isbn_input = [
    {
        label: '已有ISBN码',
        value: '1',
    },
    {
        label: '无ISBN码',
        value: '2',
    },
    {
        label: '正在申请ISBN码',
        value: '3',
    }
]

export const isbn_date = [
    {
        label: '预计时长30天',
        value: 30,
    },
    {
        label: '预计时长45天',
        value: 45,
    },
    {
        label: '预计时长60天',
        value: 60,
    }
]